import { render } from "./Table.vue?vue&type=template&id=c66a3734&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=c66a3734&lang=less&scoped=true"

import exportComponent from "D:\\code\\m_pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c66a3734"]])

export default __exports__